import type { RawLoadMeasures } from '../../infra/LoadMeasuresMapper'
import type { Commodity } from '../domain/Commodity'
import type { RawCommodity, RawItem } from '../domain/RawShippingItems'
import type { ShippingItem, ShippingItemsMeasures } from '../domain/ShippingItem'

export function mapShippingItemCommodities(commodities?: RawCommodity[]): Commodity[] {
  if (!commodities) {
    return []
  }
  return commodities.map(
    (commodity: RawCommodity): Commodity => ({
      uuid: commodity.uuid,
      description: commodity.description,
      freightClass: commodity.freight_class,
      hazmat: commodity.hazmat,
      hazmatClass: commodity.hazmat_class,
      hazmatPackingGroup: commodity.hazmat_packing_group,
      hazmatShippingName: commodity.hazmat_proper_shipping_name,
      nmfcCode: commodity.nmfc_code,
      packageCount: commodity.package_count,
      packageType: commodity.package_type,
      unNumber: commodity.un_number,
      weight: commodity.weight,
    })
  )
}

export function mapApiToShippingItems(items: Array<RawItem> | undefined = []): ShippingItem[] {
  try {
    return items.map(
      (item: RawItem): ShippingItem => ({
        packageType: item.package_type,
        packageCount: item.package_count,
        length: item.length,
        width: item.width,
        height: item.height,
        stackable: item.stackable,
        turnable: item.turnable,
        commodities: mapShippingItemCommodities(item.commodities),
        commodity: item.commodity,
        weight: item.weight,
        pickupStopIndex: item.pickup_stop_index,
        deliveryStopIndex: item.delivery_stop_index,
      })
    )
  } catch (e) {
    return []
  }
}

export function mapApiToShippingMeasures(measures?: RawLoadMeasures | null): ShippingItemsMeasures {
  if (!measures) {
    return {
      totalWeight: undefined,
      volume: undefined,
      density: undefined,
      linearFeet: undefined,
    }
  }
  return {
    totalWeight: measures.total_weight,
    volume: measures.total_volume,
    density: measures.density,
    linearFeet: measures.total_linear_feet,
  }
}
